import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { ExpandMore } from '@material-ui/icons';

import { Accordion, AccordionDetails, AccordionSummary } from '../../../material-ui/Accordion';
import { Chip } from '../../../material-ui/Chip';
import { Typography } from '../../../material-ui/Typography';
import { downloadDefect } from '../../../../actions/defects';
import { showPdf } from '../../../../actions/documents';
import { useDefects } from '../../../../selectors/defects';
import { DocumentPrefix } from '../../../../service/constants';
import { sortObjByField } from '../../../../service/sort';
import { LIMITATIONS } from '../constants';
import { useStyles } from '../useStyles';

export const Limitations = memo(({ expanded, onChangeExpand }) => {
    const defects = useDefects();
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const countLimitation = Object.keys(defects).length;

    const handleChange = useCallback(() => onChangeExpand(LIMITATIONS), []);

    const handleClick = useCallback((id, isDownloaded, name) => {
        if (isDownloaded) {
            dispatch(showPdf(`${DocumentPrefix.DEFECT}${id}`));
        } else {
            dispatch(downloadDefect(id, name));
        }
    }, []);

    if (!defects || countLimitation === 0) {
        return null;
    }

    return (
        <Accordion expanded={expanded} onChange={handleChange}>
            <AccordionSummary expandIcon={<ExpandMore />} IconButtonProps={{ size: 'small' }}>
                <Typography>{`${translate('labels.limitations')} (${countLimitation})`}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.content}>
                {defects.sort(sortObjByField('name')).map(({ code, id, isDownloaded, name }) => (
                    <Chip
                        key={id}
                        className={classnames(classes.documentButton, isDownloaded ? null : classes.warningButton)}
                        label={code ? code : name}
                        variant="outlined"
                        onClick={() => handleClick(id, isDownloaded, name)}
                    />
                ))}
            </AccordionDetails>
        </Accordion>
    );
});

Limitations.displayName = 'Limitations';
